import React from "react";
import { generateCityContent, boldKeywords } from "../data/seoContent";

const HTML = (txt) => ({ __html: txt });

export const SeoContent = ({ city }) => {
  const v = city || "93";
  const c = generateCityContent(v);

  return (
    <section className="py-20 md:py-28 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-xs sm:text-sm font-bold uppercase tracking-[0.25em] text-[#FF5A1F] mb-4">
          {city ? `Notre service à ${city}` : "Notre expertise"}
        </div>
        <h2
          className="text-3xl sm:text-4xl md:text-5xl font-extrabold tracking-tight text-[#0F172A] mb-8 leading-tight"
          style={{ fontFamily: "'Cabinet Grotesk','Manrope', sans-serif" }}
          dangerouslySetInnerHTML={HTML(
            boldKeywords(
              city
                ? `Debouchage canalisation ${city} : votre expert local au 01.84.16.20.60.`
                : `Debouchage canalisation 93 : votre expert local au 01.84.16.20.60.`
            )
          )}
        />

        <div className="prose prose-slate max-w-none text-slate-700 text-base md:text-lg leading-relaxed space-y-6">
          <p dangerouslySetInnerHTML={HTML(c.intro)} />

          <h3 className="text-2xl font-extrabold text-[#0F172A] tracking-tight">
            Diagnostiquer un <span className="text-[#FF5A1F]">problème de canalisation</span>
          </h3>
          <p dangerouslySetInnerHTML={HTML(c.problem)} />

          <h3 className="text-2xl font-extrabold text-[#0F172A] tracking-tight">
            Une méthodologie professionnelle
          </h3>
          <p dangerouslySetInnerHTML={HTML(c.method)} />

          <h3 className="text-2xl font-extrabold text-[#0F172A] tracking-tight">
            Présence locale et expertise terrain
          </h3>
          <p dangerouslySetInnerHTML={HTML(c.local)} />

          <h3 className="text-2xl font-extrabold text-[#0F172A] tracking-tight">
            Tarifs, garanties et engagements
          </h3>
          <p dangerouslySetInnerHTML={HTML(c.guarantee)} />

          <div className="bg-[#0F172A] text-white rounded-2xl p-6 md:p-8 my-10">
            <div className="text-xs uppercase tracking-[0.25em] text-[#FF5A1F] font-bold mb-3">
              20 raisons de nous appeler
            </div>
            <h3 className="text-2xl font-extrabold mb-5">Mots-clés & expertise locale</h3>
            <ul className="grid sm:grid-cols-2 gap-3 text-sm text-white/85">
              {c.keywordSentences.map((s, i) => (
                <li
                  key={i}
                  className="flex gap-3"
                  dangerouslySetInnerHTML={HTML(
                    `<span class="text-[#FF5A1F] font-black shrink-0">${(i + 1)
                      .toString()
                      .padStart(2, "0")}.</span><span>${s}</span>`
                  )}
                />
              ))}
            </ul>
          </div>

          <h3 className="text-2xl font-extrabold text-[#0F172A] tracking-tight">
            Un appel suffit pour résoudre votre urgence
          </h3>
          <p dangerouslySetInnerHTML={HTML(c.closing)} />
        </div>
      </div>
    </section>
  );
};

export default SeoContent;
